import { render, staticRenderFns } from "./halamanTicket.vue?vue&type=template&id=388089fe&"
import script from "./halamanTicket.vue?vue&type=script&lang=js&"
export * from "./halamanTicket.vue?vue&type=script&lang=js&"
import style0 from "./halamanTicket.vue?vue&type=style&index=0&id=388089fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports